import React, {useRef, useState} from "react";

import {MINIO_URL} from "../config"

export default function GameCard({game, onAdd}) {
    const ref = useRef(null);
    const [t, setT] = useState({rx: 0, ry: 0, s: 1});

    function onMove(e) {
        const el = ref.current;
        if (!el) return;
        const r = el.getBoundingClientRect();
        const x = e.clientX - r.left, y = e.clientY - r.top;
        const mx = r.width / 2, my = r.height / 2;
        const M = 3;
        const ry = ((x - mx) / mx) * M;
        const rx = -((y - my) / my) * M;
        setT({rx, ry, s: 1.01});
    }

    function onLeave() {
        setT({rx: 0, ry: 0, s: 1});
    }

    return (
        <div style={{perspective: "900px"}} onClick={onAdd}>
            <div
                ref={ref}
                className="game"
                onMouseMove={onMove}
                onMouseLeave={onLeave}
                style={{
                    transform: `rotateX(${t.rx}deg) rotateY(${t.ry}deg) scale(${t.s})`,
                    transition: t.s === 1 ? "transform .28s ease, box-shadow .25s" : "transform .06s linear, box-shadow .25s",
                }}
            >
                <img className="game__img" src={`${MINIO_URL}${game.id}/${game.image}`} alt={game.name}
                     title={game.name}/>

                <div className="game__body">
                    <div className="game__row">
                        <div className="game__name">{game.name}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
